module.exports = __webpack_public_path__ + "static/media/cart_black.19ceefab.svg";